import React from "react";

const TagCode = ({ row }) => {
  return <div>{row?.tag?.tagCode}</div>;
};

export default TagCode;
